<template>
    <v-row class="ma-n2">
        <v-col class="pa-2" cols="12">
            <v-text-field v-model="form.term" v-bind="attrs_input" label="필드명" @input="emit" />
        </v-col>
        <template v-if="form.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value">
            <v-col class="pa-2" cols="12">
                <v-text-field v-model="form.data" v-bind="attrs_input" type="date" label="필드값" @input="emit" />
            </v-col>
        </template>
        <template v-else>
            <v-col class="pa-2" cols="12">
                <v-switch v-model="form.isRequired" v-bind="attrs_switch" label="필수여부" @change="emit" class="mx-2" />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import { attrs_input, attrs_switch, EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },
    },
    data: () => ({
        form: initEmploymentField(),

        EMPLOYMENT_FIELD_SIDES,
        attrs_input,
        attrs_switch,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
